module.exports = __webpack_public_path__ + "static/img/book.9e82da1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/book.jpg
// module id = hlhS
// module chunks = 19